module.exports = __webpack_public_path__ + "static/media/wizualizacja-31.35ce1bfa.png";